import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { IonContent, NavController, NavParams } from '@ionic/angular';
import { Navigator } from 'src/app/services/routing/navigator';
import { CustomerModel } from 'src/app/models/customer-model';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { PASSWORD_PATTERN } from 'src/app/services/customFormValidators';
import { EventsService } from 'src/app/services/event/event.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
    @ViewChild(IonContent, { static: false }) content: IonContent;

    public loginUrl;
    public error: any = null;
    public resetPasswordForm: FormGroup;

    public customer: CustomerModel;

    public passwordGroup: AbstractControl;
    public newPassword: AbstractControl;
    public confirmPassword: AbstractControl;
    public securityGroup: AbstractControl;
    public securityAnswer: AbstractControl;
    public secondSecurityAnswer: AbstractControl;
    public showPasswordReset: boolean;
    public hasToken: boolean;
    public securityQuestionFirst: any;
    public securityQuestionTwo: any;
    public customerid: any;
    public showForm: boolean = true;
    public updateSuccess: boolean = false;
    public showIncomplete: boolean = false;
    public showPassword: boolean;
    public showConfirmPassword: boolean;
    public tokenURL: string;

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        // public authProvider: AuthenticationProviderService,
        public userSession: UserSessionService,
        public successMessageProvider: SuccessMessageService,
        public config: ConfigService,
        public utils: UtilsService,
        private events: EventsService,
        public navigator: Navigator,
        public authenticationService: AuthenticationService,
        private route: ActivatedRoute
    ) {
        this.successMessageProvider.clearMessage();
        this.loginUrl = `${this.config.getConfig().LOBBY_URL}?r=0#load-dialog=login`;
        //Fetch the Token from navParams logic
        let holdURL = this.navParams.get('tokenURL');
        console.log(holdURL)
        let getQueryString = holdURL.split("?")[1]
        let token = getQueryString.split('=')[1];
        this.tokenURL = token.split('#')[0];
        console.log(this.tokenURL)
        this.getToken(this.tokenURL);
    }

    ngOnInit() {
        //this.getToken();

        this.resetPasswordForm = new FormGroup({
            securityGroup: new FormGroup({
                securityAnswer: new FormControl('', [Validators.required]),
                secondSecurityAnswer: new FormControl('', [Validators.required])
            }),
            passwordGroup: new FormGroup({
                newPassword: new FormControl('', [Validators.required, Validators.minLength(8), Validators.pattern(PASSWORD_PATTERN)]),
                confirmPassword: new FormControl('', [Validators.required, Validators.minLength(8), Validators.pattern(PASSWORD_PATTERN)]),
            }, this.passwordMatchValidator),
        });

        this.securityGroup = this.resetPasswordForm.get('securityGroup');
        this.securityAnswer = this.securityGroup.get('securityAnswer');
        this.secondSecurityAnswer = this.securityGroup.get('secondSecurityAnswer');

        this.passwordGroup = this.resetPasswordForm.get('passwordGroup');
        this.newPassword = this.passwordGroup.get('newPassword');
        this.confirmPassword = this.passwordGroup.get('confirmPassword');
    }

    getToken(data) {
        /*this.route.queryParams.subscribe((params) => {
          let token = params.token;
          if(token) {
            this.utils.removeUrlParams();
            this.onValidateToken(token);
        } else {
            console.log('token not received');
        }
        });*/
        if (data) {
            this.utils.removeUrlParams();
            this.onValidateToken(data);
        } else {
            console.log('token not received');
        }

    }

    passwordMatchValidator(g: FormGroup) {
        return g.get('newPassword').value === g.get('confirmPassword').value ? null : { 'mismatch': true };
    }

    onValidateToken(token) {
        this.authenticationService.callValidateToken(token).subscribe(
            (response: any) => {
                this.successMessageProvider.clearMessage();
                this.error = null;
                if (response && !!response.result) {
                    this.error = null;

                    this.content.scrollToTop();

                    if (response.payload.security_questions === null) {
                        // If user has only completed step 1 of registration, but not step 2, direct user to customer support
                        // Step 2 contains the security question/answer pair, which is not set until step 2 is submitted
                        this.showForm = false;
                        this.showIncomplete = true;
                    } else if (response.payload.security_questions[0] === null) {
                        // Ensure the first question is not null
                        this.showForm = false;
                        this.showIncomplete = true;
                    } else {
                        this.securityQuestionFirst = response.payload.security_questions[0];
                        this.securityQuestionTwo = response.payload.security_questions[1];
                        this.customerid = response.payload.customer_id;
                        this.hasToken = true;
                        this.showForm = true;
                    }
                }
            },
            (error) => {
                switch (error.getErrorCode().toUpperCase()) {
                    case 'INVALID_TOKEN':
                        error.setErrorMessage('The token provided is invalid');
                        this.showForm = false;
                        this.showIncomplete = true;
                        break;
                    case "TOKEN_EXPIRED":
                        error.setErrorMessage('The token provided is expired');
                        this.showForm = false;
                        this.showIncomplete = true;
                        break;
                }

                this.error = error;
                this.content.scrollToTop(10);
            }
        );
    }

    onSubmit() {
        this.successMessageProvider.clearMessage();
        this.authenticationService.callResetPassword(this.resetPasswordForm.value, this.customerid)
            .subscribe(
                (response: any) => {
                    this.error = null;
                    if (response && !!response.result) {
                        this.error = null;
                        this.successMessageProvider.setMessage("Your password has been reset.");
                        this.events.publish("event:password:reset", {});
                        this.content.scrollToTop(10);
                        this.showForm = false;
                        this.updateSuccess = true;
                    }
                },
                (error) => {
                    switch (error.getErrorCode().toUpperCase()) {
                        case 'INVALID_TOKEN':
                            error.setErrorMessage('The token provided is invalid');
                            this.showForm = false;
                            break;
                        case 'SECURE_NO_MATCH':
                            error.setErrorMessage(error.getErrorMessage());
                            break;
                        case 'TOKEN_EXPIRED':
                            error.setErrorMessage('The token provided is expired');
                            this.showForm = false;
                            break;
                        case 'SECURE_MAX_ATTEMPTS_REACHED':
                            error.setErrorMessage(error.getErrorMessage());
                            this.showForm = false;
                            break;
                        case 'CURRENT_PASS_NO_MATCH':
                            this.showForm = true;
                            error.setErrorMessage("Your new password can not match your current password.");
                            break;
                        default:
                            this.showForm = true;
                            error.setErrorMessage('An error occurred when resetting your password. Please try again.');
                    }
                    this.successMessageProvider.clearMessage();
                    this.error = error;
                    this.content.scrollToTop(10);
                }
            );
    }

    forgotSecurityAnswers() {
        this.navigator.navigateTo("ResetPasswordVerifyFirstStepComponent", {}, { customerId: this.customerid });
    }

    goTologin() {
        window.location.assign(`${this.config.getConfig().LOBBY_URL}#load-dialog=login`);
        return false;
    }

    hidePassword(): void {
        this.showPassword = false;
        return;
    }

    unhidePassword(): void {
        this.showPassword = true;
        return;
    }

    hideConfirmPassword(): void {
        this.showConfirmPassword = false;
        return;
    }

    unhideConfirmPassword(): void {
        this.showConfirmPassword = true;
        return;
    }
}
